import { useParams, Navigate } from "react-router-dom";
import { Separator } from "@/components/ui/separator";
import { CONTACT } from "@/content";
import { Seo } from "@/components/Seo";

const legalSeo = {
  impressum: {
    title: "Impressum | Shibuya Anime & TCG Store Köln",
    description:
      "Impressum der C&Y Shibuya Store UG (haftungsbeschränkt) – Shibuya Anime & TCG Store, Zülpicherstr. 357, 50935 Köln.",
  },
  datenschutz: {
    title: "Datenschutzerklärung | Shibuya Anime & TCG Store Köln",
    description:
      "Datenschutzerklärung des Shibuya Anime & TCG Store Köln – Informationen zum Umgang mit deinen personenbezogenen Daten.",
  },
  agb: {
    title: "AGB | Shibuya Anime & TCG Store Köln",
    description:
      "Allgemeine Geschäftsbedingungen des Shibuya Anime & TCG Store Köln (C&Y Shibuya Store UG).",
  },
  widerruf: {
    title: "Widerrufsrecht | Shibuya Anime & TCG Store Köln",
    description:
      "Informationen zum Widerrufsrecht beim Shibuya Anime & TCG Store Köln.",
  },
};

const legalContent = {
  impressum: {
    title: "Impressum",
    sections: [
      {
        heading: "Angaben gemäß § 5 TMG",
        body: [
          `${CONTACT.companyName}`,
          `Marke: ${CONTACT.storeName}`,
          `${CONTACT.addressStreet}`,
          `${CONTACT.addressCity}, Deutschland`,
        ],
      },
      {
        heading: "Vertreten durch",
        body: [
          `Geschäftsführer: ${CONTACT.manager}`,
        ],
      },
      {
        heading: "Kontakt",
        body: [
          `Telefon: ${CONTACT.phoneDisplay}`,
          `E-Mail: ${CONTACT.email}`,
        ],
      },
      {
        heading: "Registereintrag",
        body: [
          `Eingetragen im Handelsregister.`,
          `Registergericht: ${CONTACT.registerCourt}`,
          `Registernummer: ${CONTACT.hrb}`,
        ],
      },
      {
        heading: "Umsatzsteuer",
        body: [
          `Umsatzsteuer-Identifikationsnummer gemäß § 27a Umsatzsteuergesetz: ${CONTACT.vatId}`,
        ],
      },
      {
        heading: "Verantwortlich für den Inhalt",
        body: [
          `${CONTACT.companyName}, ${CONTACT.addressStreet}, ${CONTACT.addressCity}`,
        ],
      },
    ],
  },
  datenschutz: {
    title: "Datenschutzerklärung",
    sections: [
      {
        heading: "1. Datenschutz auf einen Blick",
        body: [
          "Wir nehmen den Schutz deiner persönlichen Daten sehr ernst. Diese Website ist eine reine Informations-Website ohne Nutzerkonten, ohne Bestellfunktion und ohne Tracking zu Werbezwecken.",
          "Personenbezogene Daten werden auf dieser Website nur im technisch notwendigen Umfang verarbeitet (z. B. Server-Logs des Hosting-Anbieters).",
        ],
      },
      {
        heading: "2. Verantwortliche Stelle",
        body: [
          `${CONTACT.companyName}, ${CONTACT.addressStreet}, ${CONTACT.addressCity}, Deutschland`,
          `E-Mail: ${CONTACT.email} · Telefon: ${CONTACT.phoneDisplay}`,
        ],
      },
      {
        heading: "3. Externe Dienste",
        body: [
          "Google Maps: Auf dieser Website ist eine Karte von Google Maps eingebunden. Beim Laden der Karte werden Daten (z. B. deine IP-Adresse) an Google übertragen. Anbieter: Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irland.",
          "WhatsApp: Wenn du über den WhatsApp-Button Kontakt aufnimmst, gelten die Datenschutzbestimmungen von WhatsApp (Meta Platforms Ireland Limited).",
          "Google Fonts: Zur einheitlichen Darstellung von Schriftarten nutzt diese Seite Web Fonts von Google.",
        ],
      },
      {
        heading: "4. Deine Rechte",
        body: [
          "Du hast jederzeit das Recht auf Auskunft, Berichtigung, Löschung und Einschränkung der Verarbeitung deiner personenbezogenen Daten sowie ein Beschwerderecht bei der zuständigen Aufsichtsbehörde.",
          `Wende dich dazu einfach an: ${CONTACT.email}`,
        ],
      },
    ],
  },
  agb: {
    title: "Allgemeine Geschäftsbedingungen (AGB)",
    sections: [
      {
        heading: "1. Geltungsbereich",
        body: [
          `Diese Allgemeinen Geschäftsbedingungen gelten für alle Geschäfte zwischen der ${CONTACT.companyName}, Betreiberin des „${CONTACT.storeName}“ (nachfolgend „Store“), und ihren Kundinnen und Kunden im Ladengeschäft, ${CONTACT.addressStreet}, ${CONTACT.addressCity}.`,
        ],
      },
      {
        heading: "2. Vertragsschluss",
        body: [
          "Der Kaufvertrag kommt im Ladengeschäft durch Übergabe der Ware und Zahlung des Kaufpreises zustande.",
        ],
      },
      {
        heading: "3. Ankauf von Karten",
        body: [
          "Der Ankauf von Sammelkarten erfolgt nach individueller Bewertung vor Ort. Ein Anspruch auf Ankauf besteht nicht. Der Store behält sich vor, Karten oder Produkte ohne Angabe von Gründen abzulehnen.",
          "Angekauft werden ausschließlich Originalprodukte. Bei Fälschungsverdacht wird der Ankauf abgelehnt.",
        ],
      },
      {
        heading: "4. Preise und Zahlung",
        body: [
          "Alle Preise im Ladengeschäft verstehen sich in Euro inklusive der gesetzlichen Umsatzsteuer.",
        ],
      },
      {
        heading: "5. Gewährleistung",
        body: [
          "Es gelten die gesetzlichen Gewährleistungsrechte.",
        ],
      },
    ],
  },
  widerruf: {
    title: "Widerrufsrecht",
    sections: [
      {
        heading: "Widerrufsbelehrung",
        body: [
          "Verbrauchern steht bei Fernabsatzverträgen grundsätzlich ein gesetzliches Widerrufsrecht von 14 Tagen zu.",
          "Bei Käufen im Ladengeschäft vor Ort besteht kein gesetzliches Widerrufsrecht. Umtausch oder Rückgabe sind in diesem Fall eine freiwillige Kulanzleistung – sprich uns gerne an.",
        ],
      },
      {
        heading: "Ausschluss des Widerrufsrechts",
        body: [
          "Das Widerrufsrecht besteht u. a. nicht bei versiegelten Waren, die aus Gründen des Gesundheitsschutzes oder der Hygiene nicht zur Rückgabe geeignet sind, wenn ihre Versiegelung nach der Lieferung entfernt wurde, sowie bei Waren mit schwankendem Marktpreis (z. B. Sammelkarten mit tagesaktuellem Marktwert können hiervon betroffen sein).",
        ],
      },
      {
        heading: "Kontakt für Rückfragen",
        body: [
          `${CONTACT.companyName}, ${CONTACT.addressStreet}, ${CONTACT.addressCity}`,
          `E-Mail: ${CONTACT.email} · Telefon: ${CONTACT.phoneDisplay}`,
        ],
      },
    ],
  },
};

export default function Legal() {
  const { page } = useParams();
  const content = legalContent[page];

  if (!content) {
    return <Navigate to="/" replace />;
  }

  const seo = legalSeo[page];

  return (
    <div data-testid={`legal-page-${page}`} className="mx-auto max-w-3xl px-4 py-16 sm:px-6 md:py-20">
      {seo && <Seo title={seo.title} description={seo.description} path={`/recht/${page}`} />}
      <p className="font-mono-ui text-xs uppercase tracking-[0.25em] text-primary">
        Rechtliches
      </p>
      <h1 className="mt-3 font-display text-4xl uppercase tracking-[0.04em] sm:text-5xl">
        {content.title}
      </h1>
      <Separator className="my-8 bg-border" />
      <div className="space-y-10">
        {content.sections.map((section) => (
          <section key={section.heading}>
            <h2 className="font-display text-2xl uppercase tracking-wide">
              {section.heading}
            </h2>
            <div className="mt-3 space-y-3">
              {section.body.map((paragraph, i) => (
                <p key={i} className="text-sm leading-relaxed text-muted-foreground">
                  {paragraph}
                </p>
              ))}
            </div>
          </section>
        ))}
      </div>
      <Separator className="my-8 bg-border" />
      <p className="text-xs text-muted-foreground">
        Stand: {new Date().getFullYear()} · {CONTACT.storeName}
      </p>
    </div>
  );
}
